export default __webpack_public_path__ + "static/media/35.729c3852.jpeg";